import WideskNavigation                    from '@widesk-ui/components/Navigation';
import navigation                          from '@/navigation';
import { navigationSettings }              from '@/navigation';
import View                                from '@widesk-ui/components/View';
import SiderSelectWebsiteEntertainment     from './SiderSelectWebsiteEntertainment';
import { SetStateAction }                  from 'react';
import { Dispatch }                        from 'react';
import Button                              from '@widesk-ui/components/Button';
import { LeftOutlined }                    from '@ant-design/icons';
import { RightOutlined }                   from '@ant-design/icons';
import Title                               from '@widesk-ui/components/Title';
import { useParamsToWebsiteEntertainment } from '@/hooks/useWebsiteEntertainment';
import { observer }                        from 'mobx-react-lite';
import appStore                            from '@/stores/appStore';
import React                               from 'react';
import { CloseOutlined }                   from '@ant-design/icons';
import { useMatch }                        from 'react-router-dom';
import ConfigProvider                      from 'antd/lib/config-provider';

type LayoutSiderProps = {
	collapsedState: [boolean, Dispatch<SetStateAction<boolean>>];
}

const websiteEntertainmentMenuColors = {
	darkItemBg: '#384151',
	darkSubMenuItemBg: '#2e3542',
};

const LayoutSider = observer(function (props: LayoutSiderProps) {
	const [collapsed, setCollapsed] = props.collapsedState;

	useParamsToWebsiteEntertainment();
	const hasConfigurationUrl = useMatch('/configuration/*');
	const { websiteEntertainment, isAppMenuOpened, isConfigurationMenuOpened } = appStore;

	React.useEffect(() => {
		appStore.setMenuCollapsed(collapsed);
	}, [collapsed]);

	React.useEffect(() => {
		if (hasConfigurationUrl) {
			appStore.resetWebsiteEntertainmentId();
		}
		appStore.setConfigurationMenuOpened(!!hasConfigurationUrl);
	}, [hasConfigurationUrl]);

	React.useEffect(() => {
		if (websiteEntertainment) {
			appStore.setConfigurationMenuOpened(false);
		}
	}, [websiteEntertainment]);

	return (
		<ConfigProvider theme={!isConfigurationMenuOpened ? { components: { Menu: websiteEntertainmentMenuColors } } : undefined}>
			<View flex style={{ overflow: 'auto' }} className="main-menu">

				<View flex row style={{ overflowY: 'auto', overflowX: 'hidden', scrollbarWidth: 'thin' }}>
					<div className="main-menu-sidebar">
						<SiderSelectWebsiteEntertainment collapsedState={props.collapsedState} />

						<div className="admin-settings">
							<Button
								children={null}
								title={isConfigurationMenuOpened ? 'Fermer' : navigationSettings.label}
								tooltipProps={{ placement: 'left' }}
								type="primary"
								danger={isConfigurationMenuOpened}
								style={{ width: 54 }}
								icon={isConfigurationMenuOpened ? <CloseOutlined /> : navigationSettings.icon}
								onClick={() => {
									appStore.setConfigurationMenuOpened(!isConfigurationMenuOpened);

									if (!isConfigurationMenuOpened && collapsed) {
										setCollapsed(false);
									}
								}}
							/>
						</div>
					</div>

					{isAppMenuOpened && (
						<View flex>
							<View bg={!isConfigurationMenuOpened ? websiteEntertainmentMenuColors.darkItemBg : undefined} className="main-menu__header" row>
								<Title className="main-menu__title" size={14}>
									{isConfigurationMenuOpened ? navigationSettings.label : websiteEntertainment?.renderName()}
								</Title>

								<Button type="link" onClick={() => setCollapsed(!collapsed)}>{collapsed ? <RightOutlined /> : <LeftOutlined />}</Button>
							</View>
							<WideskNavigation
								collapsed={collapsed}
								items={isConfigurationMenuOpened ? [...(navigationSettings.children || [])] : navigation(websiteEntertainment?.id as id)}
								style={{ minHeight: 'fit-content', height: '100%', display: 'flex', flexDirection: 'column' }}
							/>
						</View>
					)}
				</View>
			</View>
		</ConfigProvider>
	);
});

export default LayoutSider;
